export const FEATURE_NAME = '@zerops/zerops/feature/debug-switcher';
